import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-center mt-2"
}


import Spinner from "@/components/Base/Spinner.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TRSaveButton',
  props: {
  isLoading: {
    type: Boolean,
    default: false
  },
  textTitle: {
    type: String,
    default: 'Speichern'
  },
  clickEvent: {
    type: Function,
    required: true
  }
},
  setup(__props) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["relative flex text-center items-center flex-col p-2 bg-white hover:bg-trader-blue hover:text-white", { 'hover:bg-trader-light-gray': props.isLoading }]),
      disabled: props.isLoading,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.clickEvent()))
    }, _toDisplayString(props.textTitle), 11, _hoisted_2),
    (props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(Spinner)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})